/** Copy for the Integrations tab. Held here so tests assert on the same strings the UI shows. */

export const INTEGRATIONS_SAVE_SUCCESS = 'You have successfully updated the integration details';

export const INTEGRATIONS_SAVE_FAILURE = 'Could not save the integration details';

export const INTEGRATIONS_LOAD_FAILURE = 'Could not load the integration details';

export const INTEGRATIONS_EMPTY =
  'No installed integration asks for anything on this record. A connector that needs one declares it on its addon.';

export const REQUIRED_BADGE = 'Needed by this integration';

/** The id the save bar's button targets, as the other price scheme tabs do it. */
export const INTEGRATIONS_FORM_ID = 'integrations-form';
